import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/view/:id',
      component: () => import(/* webpackChunkName: 'App' */'./App/index.vue'),
    },
    {
      path: '/view',
//      redirect: '/view/0'
      redirect: '/view/29'
    },
    {
      path: '/top',
      component: () => import(/* webpackChunkName: 'Top' */'./Top/index.vue'),
    },
    {
      path: '*',
      redirect: '/top'
    }
  ],
})
